/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocsCatalogControllerCatalogQueryResponse } from "../../models/documentsController/DocsCatalogControllerCatalog";

function getDocsCatalogControllerCatalogUrl() {
  const res = { method: 'GET', url: `/api/v1/documents/docs/catalog` as const }  
  return res
}

/**
 * @summary List the documents resource’s markdown docs
 * {@link /api/v1/documents/docs/catalog}
 */
export async function docsCatalogControllerCatalog(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocsCatalogControllerCatalogQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getDocsCatalogControllerCatalogUrl().url.toString(), ... requestConfig })  
  return res.data
}